export default "__VITE_ASSET__B0QJ0udt__"